import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Mic, Calendar, User } from "lucide-react";

const MIC_IMG = "https://customer-assets-7cd3h4nn.emergentagent.net/job_wanderer-network/artifacts/u4wgug0x_file_0000000020888230a9004bc8896417ef.png";

function getEmbedUrl(url) {
  if (!url) return "";
  if (url.includes("spotify.com") && !url.includes("/embed/")) {
    return url.replace("open.spotify.com/", "open.spotify.com/embed/");
  }
  if (url.includes("youtube.com/watch?v=")) {
    const id = new URL(url).searchParams.get("v");
    return `https://www.youtube.com/embed/${id}`;
  }
  if (url.includes("youtu.be/")) {
    const id = url.split("youtu.be/")[1].split("?")[0];
    return `https://www.youtube.com/embed/${id}`;
  }
  return url;
}

export default function Podcast() {
  const [episodes, setEpisodes] = useState([]);

  useEffect(() => {
    api.get("/podcast").then((r) => setEpisodes(r.data));
  }, []);

  return (
    <div data-testid="podcast-page">
      <section className="relative h-[40vh] min-h-[320px] overflow-hidden">
        <img src={MIC_IMG} alt="50 States Sober microphone with tour RV artwork" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-r from-black/85 via-black/55 to-black/25" />
        <div className="absolute inset-0 flex items-center">
          <div className="max-w-7xl mx-auto px-6 md:px-10 w-full text-white">
            <div className="overline text-[var(--sand)] mb-3">Voices of recovery</div>
            <h1 className="font-serif-display text-5xl md:text-6xl leading-none">Real stories. Every day.</h1>
            <p className="text-white/80 mt-5 max-w-xl">Daily interviews with people who've walked through addiction — and the ones still walking. Listen, share, and pass it to someone who needs it.</p>
          </div>
        </div>
      </section>

      <section className="max-w-5xl mx-auto px-6 md:px-10 py-16 md:py-20">
        {episodes.length === 0 ? (
          <div className="text-center py-16 text-[var(--ink-soft)]">No episodes yet — the first interview is on its way.</div>
        ) : (
          <div className="space-y-12">
            {episodes.map((ep) => (
              <article key={ep.id} data-testid={`podcast-${ep.id}`} className="fade-up">
                <div className="flex items-center gap-4 text-xs text-[var(--ink-soft)] font-mono-acc mb-3">
                  <span className="inline-flex items-center gap-1.5"><Calendar className="w-3.5 h-3.5" /> {ep.episode_date}</span>
                  {ep.guest && <span className="inline-flex items-center gap-1.5"><User className="w-3.5 h-3.5" /> {ep.guest}</span>}
                </div>
                <h2 className="font-serif-display text-3xl md:text-4xl mb-3">{ep.title}</h2>
                <p className="text-[var(--ink-soft)] leading-relaxed mb-5 max-w-3xl">{ep.description}</p>
                {ep.embed_url && (
                  <div className="rounded-sm overflow-hidden border border-[var(--line)]">
                    <iframe
                      src={getEmbedUrl(ep.embed_url)}
                      width="100%"
                      height={ep.embed_url.includes("spotify") ? "232" : "360"}
                      frameBorder="0"
                      allowFullScreen
                      allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                      title={ep.title}
                    />
                  </div>
                )}
              </article>
            ))}
          </div>
        )}
      </section>
    </div>
  );
}
